import { useState } from 'react';
import { FormControl, FormLabel, Stack } from '@chakra-ui/react';
import { Field } from 'formik';
import FormikInput from 'components/forms/new/formikFormFields/NameField';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../walkthroughIds';

const OfferingIdField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.offeringId && touched.offeringId}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Offering ID
                </FormLabel>
                <Field
                    as={FormikInput}
                    id="offeringId"
                    name="offeringId"
                    placeholder="e.g. 01tNq000008vsDZIAY"
                    maxLength={100}
                    data-walkthroughid={
                        walkthroughIds.createMode.ufOfferingIdInput
                    }
                    error={errors.offeringId}
                />
                {isHovered && (
                    <FieldToolTip
                        label="8×8 Product Offering identifier."
                        ariaLabel="catalog-offering-id-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default OfferingIdField;
